/**
 * @generated SignedSource<<aaf4ad899a0399f6d41f219140830269>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MultipleArtists_artists$data = ReadonlyArray<{
  readonly displayName: string;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"useArtistThumbnailUrl_artist">;
  readonly " $fragmentType": "MultipleArtists_artists";
}>;
export type MultipleArtists_artists$key = ReadonlyArray<{
  readonly " $data"?: MultipleArtists_artists$data;
  readonly " $fragmentSpreads": FragmentRefs<"MultipleArtists_artists">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "MultipleArtists_artists",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useArtistThumbnailUrl_artist"
    }
  ],
  "type": "ArtistNode",
  "abstractKey": null
};

(node as any).hash = "087d1a3c2b3cf564d763aa485b83b602";

export default node;
